import { jsx as _jsx } from "react/jsx-runtime";
import { hideModal, selectLayoutUi } from "@adm-media/adam-store-plugin";
import Row from "../../ui/Row/Row";
import classNames from "classnames";
import { useAppDispatch } from "../../../store";
import { LOGIN_MODAL } from "..";
import AuthBlock from "../../functional/AuthBlock/AuthBlock";
import { useSelector } from "react-redux";
import { LoginForm } from "../../blocks/LoginForm/LoginForm";
import "./LoginModal.scss";
export var LoginModal = function (_a) {
    var _b;
    var _c = _a.defaultAuthState, defaultAuthState = _c === void 0 ? "login" : _c;
    var dispatch = useAppDispatch();
    var layoutUi = useSelector(selectLayoutUi);
    var onLoginSuccess = function (payload) {
        if (payload === null || payload === void 0 ? void 0 : payload.token)
            dispatch(hideModal({ name: LOGIN_MODAL }));
    };
    var onRegisterSuccess = function () {
        dispatch(hideModal({ name: LOGIN_MODAL }));
    };
    var doesThemeHaveRegistrationForm = !!((_b = layoutUi === null || layoutUi === void 0 ? void 0 : layoutUi.children) === null || _b === void 0 ? void 0 : _b.find(function (child) { return (child === null || child === void 0 ? void 0 : child.component) === "RegistrationForm"; }));
    return (_jsx(Row, { children: doesThemeHaveRegistrationForm ? (_jsx(LoginForm, { noBackground: true, noGutter: true, verticalSpacing: "none", titleLevel: 3, onSuccessCallback: onLoginSuccess })) : (_jsx(AuthBlock, { defaultAuthState: defaultAuthState, onLoginSuccess: onLoginSuccess, onRegisterSuccess: onRegisterSuccess })) }));
};
export var getLoginModalProps = function () {
    return {
        modalClassName: classNames("login-modal")
    };
};
export var getRegisterModalProps = function () {
    return {
        modalClassName: classNames("login-modal"),
        defaultAuthState: "register"
    };
};
